var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 15.125C11.6055 15.125 12.375 14.3555 12.375 13.4062C12.375 12.457 11.6055 11.6875 10.6562 11.6875C9.70701 11.6875 8.9375 12.457 8.9375 13.4062C8.9375 14.3555 9.70701 15.125 10.6562 15.125Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15625 1.375H8.25C10.1485 1.375 11.6875 2.91402 11.6875 4.8125V6.53125C11.6875 7.48049 12.457 8.25 13.4062 8.25H15.125C17.0235 8.25 18.5625 9.78902 18.5625 11.6875V18.9062C18.5625 19.8555 17.793 20.625 16.8438 20.625H5.15625C4.20701 20.625 3.4375 19.8555 3.4375 18.9062V3.09375C3.4375 2.14451 4.20701 1.375 5.15625 1.375ZM10.6562 16.5C11.2617 16.5 11.8265 16.3261 12.3034 16.0255L13.264 16.9861C13.5325 17.2546 13.9678 17.2546 14.2363 16.9861C14.5048 16.7177 14.5048 16.2824 14.2363 16.0139L13.2756 15.0532C13.5761 14.5763 13.75 14.0116 13.75 13.4062C13.75 11.6976 12.3649 10.3125 10.6562 10.3125C8.94762 10.3125 7.5625 11.6976 7.5625 13.4062C7.5625 15.1149 8.94762 16.5 10.6562 16.5Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 4.8125C13.0625 3.60887 12.6206 2.50844 11.8903 1.66458C15.0059 2.47846 17.459 4.93155 18.2729 8.04724C17.4291 7.31687 16.3286 6.875 15.125 6.875H13.4062C13.2164 6.875 13.0625 6.7211 13.0625 6.53125V4.8125Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrial);
export default __webpack_public_path__ + "static/media/audit_trial.d26b72462644565f84d64d52463102ff.svg";
export { ForwardRef as ReactComponent };